var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_41_1891)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 1.33325H4.66665C2.8257 1.33325 1.33331 2.82564 1.33331 4.66658V11.3333C1.33331 13.1742 2.8257 14.6666 4.66665 14.6666H11.3333C13.1743 14.6666 14.6666 13.1742 14.6666 11.3333V4.66658C14.6666 2.82564 13.1743 1.33325 11.3333 1.33325Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6656 7.58118C10.7479 8.13601 10.6531 8.70266 10.3948 9.20052C10.1364 9.69839 9.72768 10.1021 9.22666 10.3543C8.72565 10.6065 8.15788 10.6942 7.6041 10.6051C7.05033 10.516 6.53875 10.2546 6.14214 9.85795C5.74552 9.46134 5.48406 8.94976 5.39495 8.39599C5.30584 7.84221 5.39362 7.27444 5.64579 6.77343C5.89797 6.27241 6.3017 5.86367 6.79957 5.60534C7.29743 5.34701 7.86408 5.25224 8.41891 5.33451C8.98486 5.41843 9.50881 5.68215 9.91337 6.08672C10.3179 6.49128 10.5817 7.01523 10.6656 7.58118Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 11.6667,
    cy: 4.33325,
    rx: 1,
    ry: 1,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41_1891"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.45c44bc6b98dae9ae3a2db8c3b937074.svg";
export { ForwardRef as ReactComponent };